<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Business Accelerator' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/business_accelerator_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Introduction
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0">
                        
                        Most people think that buyers are ready to purchase as soon as they click the “buy now” button. But in reality, buyers are still looking for reasons not to buy. They’re wondering if they can trust you or if they are making the right decision buying. 
                        <br><br>
                        Your cart page should keep the buyer in “buying mode” so you don’t lose the sale. We lose most of the money on the cart page. 
                        <br><br>
                        What most people don’t realize is a very high percentage exit off and it’s also the last step in the customer’s journey: before they buy. It’s the most important step. 
                        <br><br>
                        You can double your conversions just by fixing your cart page and optimizing it using some key elements.
                        <br><br>
                        You should also offer a simple order bump as well to boost your AOV right off the bat, before they proceed to the upsell or downsell.
                        <br><br>
                        Around 90% of buyers abandon the cart. That’s a huge percentage. Think about it, literally only 10% finish the checkout and buy. Just by lowering that rate with 10% will double your conversions and revenue.
                        <br><br>
                        So let’s talk about how to structure a great checkout page so it actually converts.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Structure
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
                        <strong> Should I use a one-page checkout or a multi-step checkout? </strong>
                        <br>
                        The fact is the majority of buyers  prefer a one-page checkout. That’s because a multi-step checkout process  appears more complex and requires too much of their time and effort and will abandon the purchase altogether.
                        <br><br>
                        A one-page checkout requires the buyer to make fewer clicks and appears easier to fill out. This is ideal for impatient shoppers that have no time to waste during their shopping sessions. 
                        <br><br>
                        E-commerce businesses can sell more, faster this way because it captures impulsive buyers. If the buyer is already a customer and has purchased something previously, you can implement a one-click checkout which encourages impulse purchasing. It won’t allow them to have second thoughts, the sale will be completed with the 1st click.
                        <br><br>
                        Also, make sure to ask customers to fill only required data. Don’t ask for a lot of data you’ll never gonna use. For example, if you sell a digital product, don’t ask for address or shipping information. I know it’s kinda obvious, but there are a lot of businesses that ask for all the data you can think of and customers will abandon it if the process feels too complex.
                        <br><br>
                        <strong>Order Summary</strong> <br>
                        Add an order summary of what’s included in the order, either the products or the bonuses that are offered. Especially if there are bonuses.
                        <br><br>
                        <strong>Urgency</strong> <br>
                        Add the urgency once again, the one from the sales page. Scarcity will push people to take the leap and purchase.
                        <br><br>
                        <strong>Reaffirm the guarantee</strong> <br>
                        Add the urgency once again, the one from the sales page. Again, make sure the guarantee is strong and it destroys any risk or objects customers could have.
                        <br><br>
                        <strong>Offer Recap</strong> <br>
                        People don’t take action by themselves, they always need a push, they need to be challenged. The best way to do this is to make the initial offer even more enticing. 
                        <br><br>
                        Make sure to add your USP ( Unique Selling Point ) and list the benefits once again. Try making the offer more attractive and challenge them to take action.
                        <br>
                        An example of a high-converting checkout page looks like: <br>
                        - Col 1: Urgency, 5 field checkout, Order bump, payment methods, Seal trust and security <br>
                        - Col 2: order summary, Reaffirm the guarantee and add emotional copy that highlights benefits
                        <br><br>
                        
                        <img src="@/assets/images/Checkout-structure-mockup-01.jpg" class="w-100 h-auto" />
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Order Bumps -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Order Bumps
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2">
                        
                        Order bumps are a quick and easy way to add value to your order right off the bat, but it needs to be done correctly.
                        <br><br>
                        Make sure to keep it short and simple, 1 title and up to 50 words that describe the product should suffice.
                        <br><br>
                        Make sure that it`s easy to add them to the order, with just 1 click or 1 checkbox.
                        <br><br>
                        Make sure it’s cheaper than the front-end offer. If the front-end offer is $50, make the order bump at 30, for example.
                        <br><br>
                        Most importantly, make sure it’s a product related to the front-end product sold, like an add-on. Don’t sell random products that don’t are not complementary to the initial one as you will lose the sale.
                        <br><br>
                        Example Order bumps: <br>
                        Order bump lower if front end is high ( $200 front -> $99 order bump )<br>
                        Order bump higher if front end is low ( $20 front -> 99 bump )
                        <br><br>
                        Also, try to fit everything above-the-fold, at least for desktop. Above-the-fold means that it should fit in the initial screen, before you have to scroll.
                        <br><br>
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Order Bumps -->
            
            <!-- Exit pop -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-3 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Exit pop
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion3" > {{ calculateRead('accordion3') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion3">
                        
                        This is the cherry on top of the cake that will make the cart page perfect. 
                        The exit pop is a pop-up box that will fire when it detects that the buyer wants to leave the window: close or change the tab. You can’t know for sure if they want to close or change or go back, however,  you can keep them intrigued.
                        <br><br>
                        You can offer a big discount here, between 20-30% to stimulate the buyer. If you cannot offer that, due to other expenses or margin, you can add a free gift, a course, bonus or even a mystery gift if they add their email, which will allow you to follow-up and retarget.
                        <br><br>
                        Golden nugget: One issue we found was that this cannot be fired on mobile as it cannot detect where your thumb is, as opposed to desktop detecting where the mouse is
                        <br><br>
                        However, a good strategy and a workaround is to track the average session duration for mobile users and fire the exit pop on mobile prior to that. So if for example, your average session duration is 30 seconds, fire the exit pop 20 or 25 seconds after they loaded the page.
                        <br><br>
                        Always try to get their email. Offer the bonus or discount only if they opt-in their email. Some won’t buy the initial offer but still get the bonus from the exit pop. And you can follow-up with them and retarget them in order to eventually convert.
                        <br><br>
                        If you need to follow-up, make sure to have a 3-5 day follow-up sequence.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Exit pop -->
            
            <!-- Upsells -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-4 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Upsells
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion4" > {{ calculateRead('accordion4') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-4"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion4" >
                        
                        An upsell is a technique used to increase AOV by doubling sales. It should be used in conjunction with a front-end offer in order to create an impulse buy.
                        <br><br>
                        When you’re looking to increase sales, the best buyers are those who have already purchased from you. They already trust you, so they’re more likely to buy again. 
                        <br><br>
                        It’s easier to sell to an existing customer than it is to convert a new one. 
                        <br><br>
                        Upselling helps you offer more to these customers without much extra cost. Every big business or marketer has that dialed in. <strong>The secret to generating more sales is having a couple of upsells implemented along with a backend offer.</strong>
                        <br><br>
                        Upsells should double your front-end, for low-ticket funnels. For high-tickets, you won’t be able to do that, but you can add an upsell of about 30% of the price ( if you sell a 3k offer, you can add a bonus of 1k for example ).
                        <br><br>
                        <strong>What makes a great upsell</strong>
                        <br>
                        1. Accelerates or compliments initial purchase <br>
                        For example, airlines offer complementary products after purchasing: extra leg room, custom seating, first-class upgrade, car renting options or hotel rooms for when you land. Another exmaple is Booking.com upsells rent a car and offers guides for that city
                        <br><br>
                        2. Must be congruent with avatars pains and goals
                        <br><br>
                        3. Easy to understand: make it short and simple
                        <br><br>
                        4. Must be an irresistible offer: quick, spontaneous purchase decision
                        <br><br>
                        5. Urgency: make it clear that this purchase has urgency, is limited: if they don’t buy it now, they won’t be able to buy this on other pages

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Upsells -->
            
            <!-- Downsells -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-5 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Downsells
                        <div class="float-right graymedium-color h5 mt-3 ml-2" > 
                            <span id="accordion5" > {{ calculateRead('accordion5') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-5"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion5" >
                        
                        This technique is used when the customer, for some reason, decides to back down from the purchase. In this case, you can offer him a cheaper product, which has a higher chance of being accepted. The goal here is to acquire a customer, even if you will not profit as much as possible right away.
                        <br><br>
                        If you have a $200 upsell, you can also add a downsell at $99 ( 50% ) if you don’t have any margin. 
                        <br><br>
                        Example Upsell Flow: <br>
                         - Upsell 1 - more expensive / aggressive <br>
                         - Upsell 2 - mid range <br>
                         - Upsell 3 - low ticket / trial but with continuity ( subscription )
                        <br><br>
                        On a low ticket, the upsell should double the frontend offer.


                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Downsells -->

          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
        
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/business-accelerator/03-checkout.vue